import type { Opt } from '@jet/environment/types/optional';
import type { Writable } from 'svelte/store';
import type { TrackLockup } from '~/jet/models';
// import type { LibrarySong } from '~/jet/intents/library/songs/types';
import type { Artwork, Lockup, TrackLockupLayoutStyle } from '~/jet/models';

export interface LibrarySong {
    id: string;
    albumName?: Opt<string>;
    // artistName?: Opt<MusicAPIResourceAttributes['artistName']>;
    artistName?: Opt<string>;
    // name?: Opt<MusicAPIResourceAttributes['name']>;
    name?: Opt<string>;
    artwork?: Opt<Artwork>;
    // durationInMillis?: Opt<MusicAPIResourceAttributes['durationInMillis']>;
    durationInMillis?: Opt<string>;
    // playAction?: ActionModel;
    // pauseAction?: PausePlaybackAction;
    // resumeAction?: ResumePlaybackAction;
    contentRating?: string;
    // contentDescriptor?: ContentDescriptor;
}

export enum SelectionDirection {
    'up' = -1,
    'down' = 1,
}
export type ItemSelectorItem = TrackLockup | LibrarySong;

export interface ItemSelectorState<T> {
    // We can have multiple item lists on a page, that will get combined to one list for selection states
    itemLists: Map<Symbol, T[]>;
    allItems: T[];
    selectedItemsWithShiftArrows: T[];
    selectedItems: T[];
    currentMouseTarget: T | null;
    shiftArrowDirection: SelectionDirection;
    lastSelectedItemNotByShiftClick: T;
}

export interface ItemSelector<T extends ItemSelectorItem>
    extends Writable<ItemSelectorState<T>> {
    addItems(identifier: Symbol, newItems: T[]): void;
    getItems(identifier: Symbol): T[];
    selectItem(item: T): void;
    selectPreviousItem(currentItem: T): void;
    selectNextItem(currentItem: T): void;
    selectMultiple(items: T[]): void;
    selectAll(): void;
    clearSelection(): void;
    setCurrentMouseTarget(item: T | null): void;
    handleClick(item: T, e: MouseEvent): void;
    handleKeydown(e: KeyboardEvent): void;
    resetItems(identifier: Symbol): void;
}
